export const css = {
    icon: '_2h4NVjMB',
    clockIcon: '_2W135tCj',
    eyeIcon: 'QbLRsXFb',
    eyeSlashIcon: 'bDOoXpv-',
    plusIcon: 'ckPv3cdX',
    minusIcon: '_1TedFjN5',
    checkIcon: '_3X-56MuT',
    closeIcon: '_2pVhTcT0',
    leftIcon: '_3vTTqtG2',
    rightIcon: '_1xtYVXm-',
    upIcon: 'xwzkXW-L',
    downIcon: '_1hQfAeZD',
    upAltIcon: '_2mzmQ3_Q',
    downAltIcon: 'w-Wb_O9p',
    searchIcon: '_2YW5bWCG',
    barsIcon: '_2vvDT8ne',
    settingsIcon: '_2J-kYDee',
    alertIcon: '_3L1bnUDV',
    helpIcon: '_38Uh-Elj',
    infoIcon: 'u9CJieJw',
    cancelIcon: '_1y9Kcm3c',
    checkedBoxIcon: '_1zFR6vk5',
    phoneIcon: '_2Gxy2CYk',
    editIcon: 'SzZFZz5W',
    dateIcon: '_3snZClUd',
    linkIcon: '_2XpyS3VF',
    locationIcon: '_3mq0lVi6',
    secureIcon: '_2T-_bQJs',
    mailIcon: 'wo9I4WlU',
    starIcon: '_2l13gJbz',
    ' _key': 'apic-theme/apic/dojo/icon'
};
export default css;
